import { render, staticRenderFns } from "./ActivePrelisting.vue?vue&type=template&id=315e67e8&lang=pug"
import script from "./ActivePrelisting.vue?vue&type=script&lang=ts"
export * from "./ActivePrelisting.vue?vue&type=script&lang=ts"
import style0 from "./ActivePrelisting.vue?vue&type=style&index=0&id=315e67e8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/app/components/vantone/Icon.vue').default})
